export const GRADE_LEVEL_OPTIONS = [
    {
        value: 0,
        label: 'Chuẩn bị lên lớp 6'
    },
    {
        value: 6,
        label: 'Đang học hoặc kết thúc lớp 6'
    },
    {
        value: 7,
        label: 'Đang học hoặc kết thúc lớp 7'
    },
    {
        value: 8,
        label: 'Đang học hoặc kết thúc lớp 8'
    },
    {
        value: 9,
        label: 'Đang học hoặc kết thúc lớp 9'
    }
];

export const getGradeLevelLabel = value => {
    const option = GRADE_LEVEL_OPTIONS.find(item => String(item.value) === String(value));

    return option?.label || '';
};

export const sanitizeGradeLevelPayload = ({payload, isMastery}) => {
    const sanitizedPayload = {...payload};
    delete sanitizedPayload.type_exams;

    if (isMastery) {
        sanitizedPayload.band_type = 2;
    } else {
        delete sanitizedPayload.grade_level;
        sanitizedPayload.band_type = 1;
    }

    return sanitizedPayload;
};

export const buildLearningSchedulePayload = ({
    payload,
    masteryCenterId
}) => {
    return sanitizeGradeLevelPayload({
        payload,
        isMastery: Number(payload.center_id) === Number(masteryCenterId)
    });
};
